import activityApi from '@/api/activity.js';
import { isSeckillActivityLive } from '@/units/seckillLive.js';

/**
 * 从商品详情 activities 中选取当前可售的秒杀活动 id（优先进行中 ing）
 */
export function pickLiveSeckillFromActivities(activities, nowSec) {
  const now = nowSec != null ? Number(nowSec) : Math.floor(Date.now() / 1000);
  const list = Array.isArray(activities) ? activities : [];
  const hits = list.filter(
    (a) => a && a.type === 'seckill' && isSeckillActivityLive(a, now)
  );
  if (!hits.length) return null;
  const ing = hits.find((a) => a.status === 'ing');
  const pick = ing || hits[0];
  if (pick == null || pick.id == null || pick.id === '') return null;
  return String(pick.id);
}

function goodsInActivityGoodsIds(goodsId, activity) {
  if (!activity) return false;
  const gid = String(goodsId);
  const raw = activity.goods_ids;
  if (raw == null || raw === '') return false;
  return String(raw)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .includes(gid);
}

/**
 * 无 URL activity_id 时解析商品关联的进行中秒杀活动
 */
export async function resolveSeckillActivityIdForGoods(goodsId, detailData) {
  const fromDetail = pickLiveSeckillFromActivities(detailData && detailData.activities);
  if (fromDetail) return fromDetail;

  try {
    const { data } = await activityApi.list({ type: ['seckill'], list_rows: 50 });
    const list = (data && (data.data || data.list)) || [];
    const now = Math.floor(Date.now() / 1000);
    const gid = String(goodsId);
    const hits = list.filter(
      (a) =>
        a &&
        a.type === 'seckill' &&
        isSeckillActivityLive(a, now) &&
        goodsInActivityGoodsIds(gid, a)
    );
    if (!hits.length) return null;
    const ing = hits.find((a) => a.status === 'ing');
    const pick = ing || hits[0];
    return pick && pick.id != null ? String(pick.id) : null;
  } catch (e) {
    return null;
  }
}
